import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../models/error.model';
import { IMainApiService } from '../../../../../services/api.service';
import { IApiService } from '../../../../../services/api.service.base';
import { AnnotationToolType } from '../models/annotationToolType';
import { IAnnotationType } from '../models/annotationType';

export interface IGetAnnotationTypesService {
  requestAnnotationTypesAsync(request: GetAnnotationTypesRequest): Promise<GetAnnotationTypesResponse | ACDLError>;
}

export namespace IGetAnnotationTypesService {
  export const $: interfaces.ServiceIdentifier<IGetAnnotationTypesService> = Symbol('GET_ANNOTATION_TYPES_SERVICE');
}

export class GetAnnotationTypesRequest {
  projectId: string;
  constructor(projectId: string) {
    this.projectId = projectId;
  }

  get query(): string {
    return `/${this.projectId}`;
  }
}
export class GetAnnotationTypesResponse {
  annotationTypes: IAnnotationType[];

  constructor(response: IAnnotationTypesResponse) {
    this.annotationTypes = response.annotationTypes.map<IAnnotationType>((m) => ({
      ...m,
      selectorType: m.selectorType,
    }));
  }
}

interface IAnnotationTypesResponse {
  annotationTypes: IAnnotationTypeResponse[];
}
export interface IAnnotationTypeResponse {
  id: string;
  projectId: string;
  color: string;
  name: string;
  order: number;
  isUsed: boolean;
  selectorType: AnnotationToolType;
}

@injectable()
export class GetAnnotationTypesService implements IGetAnnotationTypesService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  async requestAnnotationTypesAsync(request: GetAnnotationTypesRequest): Promise<GetAnnotationTypesResponse | ACDLError> {
    const response = await this.apiService.getAsync<IAnnotationTypesResponse>(`/annotationTypes${request.query}`);
    if (response instanceof ACDLError) {
      return response;
    }
    return new GetAnnotationTypesResponse(response);
  }
}
